import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { FirebaseFirestoreService } from '../../../services/firebase.firestore.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MessageModule } from 'primeng/message';
import { ButtonModule } from 'primeng/button';
import { Batch } from '../../../constants';
import { BatchDetailsComponent } from '../batch-details/batch-details.component';
import { DialogService } from 'primeng/dynamicdialog';
import { FirebaseFunctionsService } from '../../../services/firebase.functions.service';
import { UtilityService } from '../../../services/utility.service';
import { LocationService } from '../../../services/location.service';

@Component({
  selector: 'app-available-batches',
  templateUrl: './available-batches.component.html',
  styleUrls: ['./available-batches.component.scss'],
  standalone: true,
  imports: [
    CommonModule, 
    ProgressSpinnerModule, 
    MessageModule,
    ButtonModule,
  ],
  providers: [DialogService]
})
export class AvailableBatchesComponent implements OnInit {
  availableBatches$!: Observable<Batch[]>;
  loading = true;

  constructor(
    public firestoreService: FirebaseFirestoreService,
    private firebaseFunctionsService: FirebaseFunctionsService,
    private utilityService: UtilityService,
    private router: Router,
    private dialogService: DialogService,
    private locationService: LocationService,
    private activatedRoute: ActivatedRoute
  ) {

  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      if(params['batchId']) {
        this.viewBatchDetails({batchId: params['batchId']} as Batch);
      }
    });
    // within 25 miles | 40km radius
    this.firebaseFunctionsService.getNearbyAvailableBatches(this.utilityService.location?.latitude || 0, this.utilityService.location?.longitude || 0, 40).then((data) => {
      if(data.success) {
        this.availableBatches$ = of(data.batches);
        // check if orders are duplicated in the batches and list those orders
        const duplicateOrders = new Set();
        data.batches.forEach((batch) => {
          batch.orders.forEach((order) => {
            if(duplicateOrders.has(order.orderId)) {
              duplicateOrders.add(order.orderId);
            }
          });
        });
        console.log('duplicateOrders', duplicateOrders);
        this.loading = false;
      } else {
        this.availableBatches$ = of([]);
        this.loading = false;
      }
    }, () => {
      this.availableBatches$ = of([]);
      this.loading = false;
    }).finally(() => {
      this.loading = false;
    });
  }

  viewBatchDetails(batch: Batch): void {
    // open batch details modal
    const dialogRef = this.dialogService.open(BatchDetailsComponent, {
      modal: true,
      closable: true,
      closeOnEscape: true,
      showHeader: false,
      contentStyle: {
        'height': '100%',
      },
      style: {
        'width': '100%',
        'max-width': '640px',
        'height': '100vh',
        'max-height': 'none',
        'border-radius': '0',
        'border': 'none'
      },
      data: {
        batchId: batch.batchId
      }
    });
    dialogRef.onClose.subscribe((confirmed) => {
      if(confirmed) {
        // this.router.navigate(['/batch-details', batch.batchId]);
      }
    });
  }

  acceptBatch(batch: Batch): void {
    // TODO: Implement accept batch functionality
    console.log('Accepting batch:', batch.batchId);
  }

  trackByBatchId(index: number, batch: Batch): string {
    return batch.batchId;
  }


} 